import { FormController, FormErrorText, FormTextArea, FormTextInput, Root } from './components'
import { FormFieldLabel, FormHelperText } from './primitives'

export const Form = {
  Root,
  FieldLabel: FormFieldLabel,
  HelperText: FormHelperText,
  TextInput: FormTextInput,
  TextArea: FormTextArea,
  ErrorText: FormErrorText,
  Controller: FormController
}
